import { useState } from 'react';
import useFetch from '../../../hooks/useFetch';
import { buildEndpoint } from '../EndPoints';
import { ServiceEvents } from '../shared/interfaces';

const useContractArticleService = () => {
    const { doGet, doPost } = useFetch();
    
    const [fetchingAll, setFetchingAll] = useState(false);
    const [fetchingStore, setFetchingStore] = useState(false);
    const [fetchingUpdate, setFetchingUpdate] = useState(false);
    const [fetchingDelete, setFetchingDelete] = useState(false);
    
    const getAllArticles = (contractTypeId: number, events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: buildEndpoint(`app/contract-drafting/admin/contract-types/${contractTypeId}/articles`),
            setFetching: setFetchingAll
        });
    };
    
    const storeArticle = (data: any, events: ServiceEvents = {}) => {
        doPost({
            ...events,
            url: buildEndpoint('app/contract-drafting/admin/articles/store'),
            body: data,
            setFetching: setFetchingStore
        });
    };
    
    const updateArticle = (id: number, data: any, events: ServiceEvents = {}) => {
        doPost({
            ...events,
            url: buildEndpoint(`app/contract-drafting/admin/articles/${id}/update`),
            body: data,
            setFetching: setFetchingUpdate
        });
    };
    
    const deleteArticle = (id: number, events: ServiceEvents = {}) => {
        doPost({
            ...events,
            url: buildEndpoint(`app/contract-drafting/admin/articles/${id}/delete`),
            setFetching: setFetchingDelete
        });
    };
    
    return {
        fetchingAll,
        fetchingStore,
        fetchingUpdate,
        fetchingDelete,
        getAllArticles,
        storeArticle,
        updateArticle,
        deleteArticle
    };
};

export default useContractArticleService;

